import { styled } from "@linaria/react";
import { match } from "ts-pattern";

import FlexItem from "@gx/dls/containers/FlexItem";
import FlexWrapper from "@gx/dls/containers/FlexWrapper";
import HorizontalDivider from "@gx/dls/dividers/HorizontalDivider";
import { withTheme, type PropsWithTheme } from "@gx/dls/theme";

import SelectProjectSourcesToolbar from "@/pages/projects/forms/create/components/steps/select-project-sources/SelectProjectSourcesToolbar";
import { CreateProjectFormStep } from "@/pages/projects/forms/create/types";

interface CreateProjectModalStepProps {
  step: CreateProjectFormStep;
  header: React.ReactNode;
  body: React.ReactNode;
  footer: React.ReactNode;
}

const CreateProjectModalStepWrapper = withTheme(styled.div<
  PropsWithTheme<{ $step: CreateProjectFormStep }>
>`
  display: flex;
  flex-direction: column;

  width: ${({ $step }) => {
    return match($step)
      .with(CreateProjectFormStep.CONFIGURE_PROJECT, () => "720px")
      .with(CreateProjectFormStep.SELECT_PROJECT_SOURCES, () => "820px")
      .with(CreateProjectFormStep.SELECT_MAPPING_METHOD, () => "820px")
      .exhaustive();
  }};
  height: ${({ $step }) => {
    return match($step)
      .with(CreateProjectFormStep.CONFIGURE_PROJECT, () => "auto")
      .with(CreateProjectFormStep.SELECT_PROJECT_SOURCES, () => "720px")
      .with(CreateProjectFormStep.SELECT_MAPPING_METHOD, () => "auto")
      .exhaustive();
  }};

  background-color: ${({ theme }) => theme.color.background.base};
  border: 0.5px solid ${({ theme }) => theme.color.border.primary};
  border-radius: 8px;
`);

const CreateProjectModalBodyWrapper = withTheme(styled.div<PropsWithTheme>`
  flex: 1;
  min-height: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  border-radius: 0 0 8px 8px;
  padding: 16px;
`);

const CreateProjectModalFooterWrapper = withTheme(styled.div<PropsWithTheme>`
  border-radius: 0 0 8px 8px;
  padding: 16px;
`);

const CreateProjectModalStep = ({ step, header, body, footer }: CreateProjectModalStepProps) => {
  return (
    <CreateProjectModalStepWrapper $step={step}>
      <FlexWrapper padding="16px" fillWidth>
        {header}
      </FlexWrapper>
      {step === CreateProjectFormStep.SELECT_PROJECT_SOURCES && (
        <>
          <HorizontalDivider />
          <FlexWrapper padding="8px 12px" fillWidth>
            <SelectProjectSourcesToolbar />
          </FlexWrapper>
        </>
      )}
      <FlexItem shrink={0} grow={0}>
        <HorizontalDivider />
      </FlexItem>
      <CreateProjectModalBodyWrapper>{body}</CreateProjectModalBodyWrapper>
      <HorizontalDivider />
      <CreateProjectModalFooterWrapper>{footer}</CreateProjectModalFooterWrapper>
    </CreateProjectModalStepWrapper>
  );
};

export default CreateProjectModalStep;
